import type { Dictionary } from './dictionaryTypes';
import { EN } from './en';

export const AR: Dictionary = {
    localeLabel: 'العربية',
    languages: {
        ru: 'الروسية',
        en: 'الإنجليزية',
        es: 'الإسبانية',
        fr: 'الفرنسية',
        ar: 'العربية',
        'zh-CN': 'الصينية المندرينية',
        'zh-HK': 'الصينية الكانتونية',
    },
    common: {
        close: 'إغلاق',
        done: 'تم',
        settings: 'الإعدادات',
        preferences: 'التفضيلات',
        logout: 'تسجيل الخروج',
        loading: 'جارٍ التحميل…',
        copied: 'تم النسخ!',
        backToDashboard: 'العودة إلى اللوحة',
        backToChats: 'العودة إلى الدردشات',
        backToRecordings: 'العودة إلى التسجيلات',
        login: 'تسجيل الدخول',
        forInvestors: 'للمستثمرين',
        learnMore: 'اعرف المزيد',
        chats: 'الدردشات',
        email: 'البريد',
        openCall: 'فتح المكالمة',
        currentBrowser: 'هذا المتصفح',
        anotherDevice: 'جهاز آخر',
        thisBrowser: 'هذا المتصفح',
        moreActions: 'إجراءات إضافية',
    },
    appError: {
        title: 'حدث خطأ ما',
        description: 'تم تسجيل الخطأ. أعد تحميل الصفحة لإعادة المحاولة.',
        retry: 'إعادة المحاولة',
    },
    offline: {
        eyebrow: 'بدون اتصال',
        title: 'الاتصال غير متاح',
        description: 'يمكنك فتح شاشات Chattenger المخزنة مؤقتاً، لكن الرسائل الجديدة والمكالمات والبريد والمزامنة تحتاج إلى اتصال.',
        openChats: 'فتح الدردشات',
    },
    compatibilityRoutes: {
        errorEyebrow: 'مسار الخطأ',
        errorTitle: 'سطح الخطأ المشترك يُعرَض الآن عبر Next.js.',
        errorDescription: 'بهذا يبقى المسار متاحاً بينما تنتقل بقية واجهة المنتج بعيداً عن الـ SPA القديمة.',
        towerEyebrow: 'مسار توافق',
        towerTitle: 'أصبحت Tower تعمل الآن عبر غلاف Next.js.',
        towerDescription: 'سيظل الانتقال إلى اللعبة متاحاً أثناء التحول من SPA إلى Next. المسار محجوز ولم يعد يعتمد على الحزمة القديمة.',
        backHome: 'العودة إلى Chattenger',
        joinEyebrow: 'الانضمام',
        joinInvalidTitle: 'رابط الدعوة غير صالح',
        joinInvalidDescription: 'رابط الدعوة هذا غير صحيح الصياغة. افتحه مجدداً في Chattenger أو اطلب رابطاً جديداً.',
        openInChattenger: 'فتح في Chattenger',
        continueOnWeb: 'المتابعة على الويب',
        joinDirectChatTitle: 'تعذر فتح الدردشة المباشرة',
        joinDirectChatDescription: 'تم التعرف على المستخدم، لكن تعذر تهيئة دردشة المتصفح حالياً. حاول فتحها في التطبيق.',
        goToDashboard: 'الانتقال إلى اللوحة',
        joinChannelEyebrow: 'الانضمام إلى القناة',
        joinGroupEyebrow: 'الانضمام إلى المجموعة',
        joinUnsupportedChannelDescription: 'تمكّن الويب من حل هذه القناة، لكنها ليست متاحة بعد في قائمة دردشات المتصفح الحالية.',
        joinUnsupportedGroupDescription: 'تمكّن الويب من حل هذه المجموعة، لكنها ليست متاحة بعد في قائمة دردشات المتصفح الحالية.',
        joinUnsupportedChannelFallback: 'افتح هذه القناة في Chattenger لمعاينتها أو لإكمال الوصول أو الاشتراك.',
        joinUnsupportedGroupFallback: 'افتح هذه المجموعة في Chattenger لمعاينتها أو لإكمال الوصول أو الاشتراك.',
        joinNotFoundTitle: 'لم يتم العثور على الدعوة',
        joinNotFoundDescription: 'تعذر حل هذه الدعوة للحساب الحالي. قد تكون غير صالحة أو خاصة أو لم تعد متاحة.',
    },
    theme: {
        system: 'النظام',
        light: 'فاتح',
        dark: 'داكن',
        label: 'السمة',
        hint: 'يتم حفظ السمة لهذا المتصفح فقط.',
    },
    settings: {
        ...EN.settings,
        eyebrow: 'الملف الشخصي والإعدادات',
        title: 'تفضيلات الواجهة',
        description: 'اللغة والسمة تبقيان مرتبطتين بهذا المتصفح حتى يعود إليك الإحساس نفسه في كل مرة.',
        appearanceTab: 'المظهر',
        devicesTab: 'الأجهزة',
        languageTab: 'اللغة',
        securityTab: 'الأمان',
        appearanceTitle: 'وضع العرض',
        appearanceCopy: 'بدّل الألوان فوراً من دون إعادة تحميل. يجب أن يبقى عميل الويب سريعاً وثابتاً على كل شاشة.',
        languageTitle: 'لغة الواجهة',
        languageCopy: 'يتم تحديث الترجمة فوراً عبر أهم أسطح الويب في جلسة المتصفح الحالية.',
        profileTitle: 'الملف الحالي',
        profileCopy: 'إعدادات هذا المستخدم وهذا المتصفح.',
        publicCopy: 'حتى الصفحات العامة تحفظ السمة واللغة على هذا الجهاز قبل تسجيل الدخول.',
        photoAction: 'الصورة',
        photoActionAria: 'اختيار صورة الملف الشخصي',
        photoUploadFailed: 'تعذّر رفع الصورة.',
        navigationTitle: 'الأقسام',
        languageLabel: 'اللغة',
        languageHint: 'الروسية والإنجليزية والإسبانية والفرنسية والعربية والصينية المبسطة والكانتونية مدعومة حالياً.',
        localeBadge: 'اللغة',
        themeBadge: 'السمة',
        accessibilityTitle: 'إمكانية الوصول',
        accessibilityCopy: 'يمكنك إيقاف طبقة إمكانية الوصول الدلالية بالكامل في هذا المتصفح إذا أردت وضعاً بصرياً محايداً من دون عقود ARIA أو role.',
        accessibilityLabel: 'إمكانية الوصول',
        accessibilityOn: 'تشغيل',
        accessibilityOff: 'إيقاف',
        focusHighlightsTitle: 'تمييز التركيز',
        focusHighlightsCopy: 'يمكنك إيقاف إبراز التركيز البصري في هذا المتصفح إذا كان مزعجاً أثناء الاستخدام العادي باللمس أو الفأرة.',
        focusHighlightsLabel: 'تمييز التركيز',
        focusHighlightsOn: 'تشغيل',
        focusHighlightsOff: 'إيقاف',
        devicesTitle: 'الأجهزة المسجّلة',
        devicesCopy: 'اعرض كل جلسات الهاتف والمتصفح وسطح المكتب لهذا الحساب. حالة الاتصال تتحدث عبر السوكت الموثق.',
        devicesLoadFailed: 'تعذّر تحميل الأجهزة.',
        devicesActionFailed: 'تعذّر تحديث جلسة الجهاز.',
        devicesEmpty: 'لم يتم العثور على أجهزة لهذا الحساب بعد.',
        devicesCurrent: 'الجهاز الحالي',
        devicesView: 'عرض',
        devicesEndSession: 'إنهاء الجلسة',
        devicesEndingSession: 'جارٍ الإنهاء…',
        devicesLoggedInAt: 'تسجيل الدخول',
        devicesUpdatedAt: 'آخر تحديث',
        devicesActiveSockets: 'سوكتات نشطة',
        devicesUserAgent: 'User agent',
        devicesStatusOnline: 'متصل',
        devicesStatusOffline: 'غير متصل',
        devicesStatusSignedOut: 'تم تسجيل الخروج',
        deviceInspectionBack: 'العودة إلى الأجهزة',
        deviceInspectionCopy: 'راجع النشاط الأخير لهذا الجهاز المسجّل. افتح الحدث لعرض البيانات الوصفية.',
        deviceInspectionEmpty: 'لا يوجد نشاط حديث بعد.',
        deviceActivityNoMetadata: 'لا توجد بيانات وصفية',
        deviceViewRequest: 'طلب عرض مباشر',
        deviceViewRequestMicrophone: 'الميكروفون فقط',
        deviceViewRequestCameraMic: 'الكاميرا + الميكروفون',
        deviceViewPermissionSummary: 'أذونات الجهاز الهدف: الميكروفون {microphone}، الكاميرا {camera}.',
        deviceViewPermissionGranted: 'مسموح',
        deviceViewPermissionPrompt: 'سيطلب إذناً',
        deviceViewPermissionDenied: 'محظور',
        deviceViewPermissionUnknown: 'غير معروف',
        deviceViewPermissionUnsupported: 'غير مدعوم',
        deviceViewPermissionHint: 'اختر الخيارات المسموح بها مسبقاً لتجنب نافذة إذن على ذلك الجهاز.',
        deviceViewIdle: 'لا يوجد طلب عرض نشط.',
        deviceViewPending: 'بانتظار بدء الكاميرا والميكروفون على الجهاز الآخر.',
        deviceViewStarting: 'جارٍ بدء الكاميرا والميكروفون.',
        deviceViewStreaming: 'الكاميرا والميكروفون يبثان الآن.',
        deviceViewPermissionRequired: 'مطلوب إذن الكاميرا أو الميكروفون على ذلك الجهاز.',
        deviceViewFailed: 'فشل العرض المباشر.',
        deviceViewStopped: 'توقف العرض المباشر.',
        deviceViewStreamingChip: '{count} جهاز يشاهد الكاميرا والميكروفون',
        deviceViewAccept: 'موافقة',
        deviceViewDecline: 'رفض',
        deviceViewPromptTitle: 'هل تسمح بعرض هذا الجهاز؟',
        deviceViewPromptBody: 'جهاز آخر مسجّل يطلب عرض هذا المتصفح. وافق فقط إذا كنت أنت من طلب ذلك.',
        deviceViewRespondFailed: 'تعذر الرد على طلب عرض الجهاز.',
        deviceViewOverlayTitle: 'عرض مباشر للجهاز',
        deviceViewOverlayCopy: 'استخدم هذه اللوحة لمتابعة حالة العرض وسجل النشاط الآمن للجهاز المحدد.',
        deviceViewOverlayMediaPending: 'سيظهر بث الكاميرا والميكروفون هنا عندما يبدأ الجهاز الآخر البث.',
        deviceViewOverlayAudioActive: 'بث الصوت نشط',
        deviceViewOverlayLogsTitle: 'سجل النشاط المباشر',
    },
    landing: {
        eyebrow: 'منصة اتصالات آمنة',
        title: 'Chattenger — فرص بلا حدود',
        description:
            'منظومة اتصالات آمنة للتحالفات والدول والشركات والفرق. اتصالات سيادية وثقة رقمية ومسار من المراسلة الموثوقة إلى بنية اقتصادية أوسع.',
        searchHint: 'Chattenger. Чаттенджер. شاتنجر.',
        openLogin: 'فتح تسجيل الدخول',
        learnMore: 'اعرف المزيد',
        badges: ['استجابة أولاً', 'مبني على السوكت', 'جاهز للمستثمرين'],
        capabilities: [
            'محادثات ومجموعات وقنوات ورسائل صوتية وفيديو دائري وتدفقات مباشرة مشفرة.',
            'تجربة محادثة واحدة سلسة بين الهاتف والمتصفح.',
            'الإدارة والدعم والتسجيلات والواجهات الأساسية داخل منتج واحد.',
        ],
        investorsEyebrow: 'BRICS / SCO / B2B / B2C',
        investorsTitle: 'Chattenger هو نواة اتصالات يمكن توسيعها إلى منظومات رقمية سيادية وخدمات عامة ومالية ولوجستية وأسقف super-app متخصصة.',
        investorsDescription:
            'تبقى الصفحة الجذرية موجهة للمستثمرين: اتصالات آمنة وسيادة رقمية وبنية mini-app قابلة للتمدد ومسار من المراسلة الموثوقة إلى بنية اقتصادية أكبر.',
        coreNow: 'الأساس الآن',
        platformDirection: 'اتجاه المنصة',
        coreList: [
            'محادثات ومكالمات وغرف جماعية وتبادل وسائط وإشعارات وتسجيلات.',
            'مراسلة خاصة ومكالمات محمية وتجربة متسقة عبر الأجهزة.',
            'الإدارة والدعم والأسطح المحمية للمشغلين.',
        ],
        platformList: [
            'mini-apps وKYC والمدفوعات واللوجستيات وCRM والإعلام والقطاع العام.',
            'اتصالات على مستوى التحالفات والدول، وليس مجرد messenger استهلاكي.',
            'منصة مرنة للإطلاقات الإقليمية والقطاعات المتخصصة.',
        ],
    },
    auth: {
        ...EN.auth,
        runtimeUnavailableTitle: 'البيئة غير متاحة',
        runtimeUnavailableDescription: 'الخادم لا يستجيب. قد يفشل تسجيل الدخول إلى أن تتعافى البيئة.',
        methodLabel: 'طريقة تسجيل الدخول',
        methodOtp: 'OTP',
        methodQr: 'QR',
        phoneLabel: 'الهاتف',
        phonePlaceholder: '8 (900) 450-65-54',
        continue: 'متابعة',
        requesting: 'جارٍ الطلب…',
        otpLabel: 'رمز OTP',
        otpHint: 'أدخل رمز التحقق.',
        callOtpHint: 'أجب على المكالمة وأدخل الرمز الذي تسمعه.',
        smsOtpHint: 'سنرسل لك رسالة SMS الآن. أدخل الرمز.',
        verify: 'تأكيد',
        verifying: 'جارٍ التحقق…',
        resendCode: 'إعادة إرسال الرمز',
        resendIn: 'إعادة الإرسال خلال {seconds}ث',
        retryCall: 'أعد الاتصال',
        retrySms: 'أعد الرسالة',
        switchToCall: 'جرّب المكالمة',
        switchToSms: 'جرّب الرسالة',
        changePhone: 'تغيير الرقم',
        requestOtpFailed: 'تعذر طلب OTP',
        verifyOtpFailed: 'تعذر التحقق من OTP',
        pendingDeviceApprovalExpiredStatus: 'انتهى',
        pendingDeviceApprovalRejectedStatus: 'مرفوض',
        pendingDeviceApprovalNotFoundStatus: 'غير متاح',
        cantLogin: 'لا يمكنك تسجيل الدخول؟',
        registrationEmailTitle: 'أكّد البريد الإلكتروني',
        registrationEmailDescription: 'أدخل الرمز الذي أرسلناه إلى بريدك قبل فتح الحساب.',
        registrationEmailSentTo: 'أرسلنا رمزاً من 4 أرقام إلى {email}.',
        trustedDeviceBootstrapEmailTitle: 'أكّد هذا الجهاز الموثوق',
        trustedDeviceBootstrapEmailDescription: 'أدخل رمز البريد الإلكتروني لإكمال تسجيل الدخول على هذا الجهاز.',
        trustedDeviceBootstrapEmailSentTo: 'أرسلنا رمزاً من 4 أرقام إلى {email}.',
        mobileRegistrationRequired: 'يجب إنشاء الحسابات الجديدة من تطبيق Chattenger للهاتف.',
        emailOtpLabel: 'رمز البريد',
        emailOtpHint: 'أدخل الرمز المكوّن من 4 أرقام من بريدك.',
        registrationRecoveryCodesTitle: 'احفظ رموز الاستعادة',
        accountRecoveryTitle: 'استعادة الحساب',
        accountRecoveryDescription: 'أدخل رمز الهاتف ورمز استعادة واحداً لإعادة ضبط الأجهزة الموثوقة.',
        recoveryCodeLabel: 'رمز الاستعادة',
        recoveryCodePlaceholder: 'CHTG-XXXX-XXXX-XXXX-XXXX',
        recoveryCodeHint: 'استخدم رمزاً احتياطياً حفظته سابقاً.',
        accountRecoveryCodesTitle: 'رموز استعادة جديدة',
        recoveryCodesDescription: 'تظهر هذه الرموز مرة واحدة فقط. احتفظ بها خاصة وبدون اتصال.',
        recoveryCodesWriteDown: 'اكتب هذه الرموز. إنها الطريقة الذاتية الوحيدة لاستعادة الحساب لاحقاً.',
        copyRecoveryCodes: 'نسخ الرموز',
        emailRecoveryCodes: 'إرسال الرموز بالبريد',
        recoveryCodesCopied: 'تم نسخ الرموز',
        recoveryCodesDeliveryTitle: 'إرسال رموز الاسترداد',
        recoveryCodesDeliveryDescription: 'أرسل نسخة إلى {email}، أو احتفظ بنسخة غير مقروءة في بريد Chattenger بعد تسجيل الدخول.',
        recoveryCodesVerifiedEmailLabel: 'بريدك المؤكد',
        recoveryCodesInboxCopyTitle: 'إنشاء نسخة غير مقروءة في بريد Chattenger',
        recoveryCodesInboxCopyDescription: 'بعد تسجيل الدخول، افتح البريد واترك رسالة الرموز غير مقروءة حتى تختارها.',
        sendRecoveryCodesEmail: 'إرسال إلى البريد',
        recoveryCodesEmailSending: 'جارٍ الإرسال…',
        recoveryCodesInboxCopyCreating: 'جارٍ إنشاء نسخة في بريد Chattenger…',
        recoveryCodesEmailSent: 'تم إرسال البريد',
        recoveryCodesNextCountdown: 'التالي ({seconds})',
        qrEyebrow: 'Chattenger Web',
        qrTitle: 'تسجيل الدخول عبر QR',
        qrDescription: 'افتح Chattenger على هاتفك وأكّد تسجيل الدخول.',
        qrInstructionOne: 'افتح Chattenger.',
        qrInstructionTwo: 'اذهب إلى الإعدادات.',
        qrInstructionThree: 'اختر تسجيل الدخول إلى الويب وامسح الرمز.',
        qrRefreshing: 'جارٍ إعداد رمز جديد…',
        qrWaiting: 'بانتظار التأكيد من الهاتف…',
        qrExpired: 'انتهت صلاحية هذا الرمز. أنشئ رمزاً جديداً.',
        qrFailed: 'تعذر تجهيز تسجيل الدخول عبر QR',
    },
    admin: {
        control: 'التحكم',
        role: 'الدور',
        roleCopy: 'أدوات الإدارة تبقى منفصلة عن تجربة المنتج اليومية.',
        nav: {
            overview: 'نظرة عامة',
            messages: 'الرسائل',
            statistics: 'الإحصاءات',
            logs: 'السجلات',
            infrastructure: 'البنية التحتية',
            wireguardInternal: 'WireGuard الداخلي',
            stands: 'المنصات',
            builds: 'البناءات',
            users: 'المستخدمون',
            permissions: 'الصلاحيات',
            db: 'قاعدة البيانات',
            docs: 'الوثائق',
            mermaid: 'محرر Mermaid',
            reports: 'البلاغات',
            email: 'البريد',
            mailboxes: 'صناديق البريد',
            terminal: 'الطرفية',
            authConfig: EN.admin.nav.authConfig,
            features: 'الميزات',
        },
        surfaceCanonicalContractLabel: EN.admin.surfaceCanonicalContractLabel,
        docsWebPlanPageTitle: EN.admin.docsWebPlanPageTitle,
        docsShellEyebrow: EN.admin.docsShellEyebrow,
        docsShellDescription: EN.admin.docsShellDescription,
        mermaid: {
            canvasLabel: 'مساحة عمل المخطط',
            editorTab: 'المحرر',
            errorLink: 'رابط المخطط غير صالح أو يتجاوز الحد الآمن.',
            errorSyntax: 'تعذر عرض المخطط. صحح صياغة Mermaid ثم أعد المحاولة.',
            fit: 'ملاءمة المخطط',
            loading: 'جارٍ تحميل المحرر…',
            pageDescription: 'حرر مخططاً خاصاً في المتصفح وشارك حالة URL محدودة من دون حفظ المصدر في Chattenger.',
            pageEyebrow: 'الإدارة / Mermaid',
            pageTitle: 'محرر Mermaid',
            previewTab: 'المعاينة',
            ready: 'المخطط جاهز',
            rendering: 'جارٍ عرض المخطط…',
            reset: 'إعادة ضبط العرض',
            share: 'نسخ رابط المشاركة',
            shareCopied: 'تم نسخ رابط المشاركة',
            shareUnavailable: 'نسخ رابط المشاركة غير متاح في هذا المتصفح.',
            sourceLabel: 'مصدر Mermaid',
            zoomIn: 'تكبير',
            zoomOut: 'تصغير',
        },
        logsPage: {
            shellEyebrow: 'الإدارة / السجلات',
            shellTitle: 'سجلات المراقبة',
            shellDescription: 'استعلام السجلات التشغيلية المدعومة من المزوّد عبر Grafana Loki وRollbar دون الرجوع إلى ذيل إداري يعتمد على القرص فقط.',
            searchLabel: 'بحث',
            searchPlaceholder: 'ابحث في الرسالة أو الحمولة أو نص التتبع',
            serviceLabel: 'الخدمة',
            sourceLabel: 'المصدر',
            sinkLabel: 'المستقبل',
            environmentLabel: 'البيئة',
            severityLabel: 'الخطورة',
            optionAnyService: 'أي خدمة',
            optionAnySource: 'أي مصدر',
            optionAnySink: 'أي مستقبل',
            optionAnyEnvironment: 'أي بيئة',
            optionAnySeverity: 'أي خطورة',
            btnApply: 'تطبيق',
            btnApplyBusy: 'جارٍ التحديث…',
            resultsNoData: 'لا بيانات سجلات',
            resultsSummaryOne: '{total} صف · صفحة {page}',
            resultsSummaryMany: '{total} صفوف · صفحة {page}',
            filtersHintCopy: 'تُطبَّق المرشحات على الخادم مع نافذة تخزين مؤقت قصيرة حتى لا تُثقل تحديثات الإدارة المتكررة على Loki أو Rollbar.',
            btnPrev: 'السابق',
            btnNext: 'التالي',
            tableColTime: 'الوقت',
            tableColService: 'الخدمة',
            tableColSink: 'المستقبل',
            tableColSource: 'المصدر',
            tableColEnv: 'البيئة',
            tableColSeverity: 'الخطورة',
            tableColMessage: 'الرسالة',
            tableColAction: 'إجراء',
            btnInspect: 'عرض',
            emptyTitle: 'لا صفوف',
            emptyCopy: 'ستظهر هنا صفوف المراقبة المطابقة بعد تهيئة موفّري Loki وRollbar القابلين للقراءة لهذه البيئة.',
            errLoadLogs: 'تعذر تحميل السجلات',
            errChangePage: 'تعذر تغيير الصفحة',
            providerFallbackLabel: 'Grafana Loki',
            providerFallbackMessage: 'لا تتوفر حالة الموفّر بعد.',
            providerOkCopy: 'تم الاستعلام عن الموفّر بنجاح لطلب الإدارة الحالي.',
            providerInactiveCopy: 'الموفّر غير نشط للطلب الحالي.',
            sheetTitleFallback: 'تفاصيل السجل',
            sheetEyebrowPattern: '{service} / {sink}',
            sheetSummaryLabel: 'ملخص',
            sheetTimeLine: 'الوقت: {time}',
            sheetEnvironmentLine: 'البيئة: {env}',
            sheetOpenProviderLink: 'فتح الحدث عند الموفّر',
            sheetRawLabel: 'خام',
            sheetPayloadLabel: 'الحمولة',
            valueEmDash: '—',
        },
        messagesPage: {
            shellEyebrow: 'الإدارة / الرسائل',
            shellTitle: 'محادثات الدعم',
            shellDescription: 'صندوق CRM مباشر لهوية دعم Chattenger المضمّنة.',
            searchLabel: 'البحث في محادثات الدعم',
            searchPlaceholder: 'البحث بالاسم أو المعرف أو الهاتف',
            btnFilter: 'تصفية',
            listEmptyTitle: 'لا توجد محادثات دعم',
            listEmptyCopy: 'ستظهر محادثات الدعم هنا عندما يبدأ المستخدمون بالكتابة إلى Chattenger.',
            noMessagesYet: 'لا رسائل بعد',
            lockedPill: 'مقفل',
            pendingStreakPill: '{count} قيد الانتظار',
            threadEyebrow: 'سلسلة الدعم',
            requesterMetaLine: '@{handle} · {count} رسائل مستخدم قيد الانتظار',
            openInNewTab: 'فتح في تبويب جديد',
            btnUnlockInput: 'إلغاء قفل الإدخال',
            btnLockInput: 'قفل الإدخال',
            staffAttributionLine: '{name} (Chattenger)',
            fallbackStaffDisplayName: 'Chattenger',
            encryptedMessage: 'رسالة مشفّرة',
            composerPlaceholderCanReply: 'الرد باسم Chattenger',
            composerPlaceholderReadOnly: 'هذا الحساب للموظفين له صلاحية قراءة فقط في CRM لمحادثات الدعم.',
            btnReply: 'رد',
            emptyDetailTitle: 'اختر محادثة دعم',
            emptyDetailHeading: 'تفتح لوحة تفاصيل CRM هنا.',
            emptyDetailCopy: 'تفاصيل الرسائل والتحديثات المباشرة وعناصر التحكم بالقفل ونسب الإجراء للمسؤول تظهر في هذه اللوحة.',
            errLoadThread: 'تعذّر تحميل سلسلة الدعم',
            errSearchConversations: 'تعذّر البحث في محادثات الدعم',
            errOpenConversation: 'تعذّر فتح هذه المحادثة',
            errSendReply: 'تعذّر إرسال رد الدعم',
            errUpdateLock: 'تعذّر تحديث قفل محادثة الدعم',
        },
        reportsPage: {
            shellEyebrow: 'الإدارة / البلاغات',
            shellTitle: 'بلاغات المنتج',
            shellDescription: 'بلاغات منتج واردة مع عوامل تصفية وتعمق وأدوات مراجعة للمشغّلين.',
            sheetEyebrowReportDetails: 'تفاصيل البلاغ',
            sheetTitleFallbackReport: 'بلاغ',
            searchLabel: 'بحث',
            searchPlaceholder: 'ابحث في العنوان وSTR وER وAR',
            userIdLabel: 'معرّف المستخدم',
            userIdPlaceholder: 'معرّف المُبلِّغ',
            statusLabel: 'الحالة',
            statusOptionAny: 'أي حالة',
            mediaLabel: 'الوسائط',
            mediaOptionAny: 'أي وسائط',
            mediaOptionVideo: 'يحتوي فيديو',
            mediaOptionImages: 'يحتوي صوراً',
            btnApply: 'تطبيق',
            btnPrev: 'السابق',
            btnNext: 'التالي',
            resultsNoData: 'لا بيانات',
            resultsSummaryOne: '{total} بلاغ · صفحة {page}/{totalPages}',
            resultsSummaryMany: '{total} بلاغات · صفحة {page}/{totalPages}',
            tableColCreated: 'تاريخ الإنشاء',
            tableColStatus: 'الحالة',
            tableColTitle: 'العنوان',
            tableColUser: 'المستخدم',
            tableColMedia: 'الوسائط',
            tableColAction: 'إجراء',
            mediaVideoTag: 'فيديو',
            valueEmDash: '—',
            mediaImageCountOne: '{count} صورة',
            mediaImageCountMany: '{count} صور',
            btnInspect: 'عرض',
            emptyTitle: 'لا بلاغات',
            emptyCopy: 'ستظهر هنا بلاغات روبوت التصحيح المطابقة بعد إنشائها.',
            errLoadReports: 'تعذر تحميل البلاغات',
            errChangePage: 'تعذر تغيير الصفحة',
            sheetUserLine: 'المستخدم {userId}',
            sheetStrLabel: 'STR',
            sheetExpectedResultLabel: 'النتيجة المتوقعة',
            sheetActualResultLabel: 'النتيجة الفعلية',
            sheetArtifactsLabel: 'المرفقات',
            sheetVideoKeyLine: 'مفتاح الفيديو: {value}',
            sheetImageKeysLine: 'مفاتيح الصور: {value}',
        },
        standaloneShellEyebrow: 'الإدارة',
        buildLastRunLabel: 'آخر تشغيل',
        buildEtaInProgressLabel: 'قيد التنفيذ',
        buildEtaLowConfidencePattern: '{phase} · موثوقية منخفضة',
        buildEtaNativeCompileLabel: 'تجميع أصلي',
        buildHistoryArchiveLabel: 'أرشيف البناء',
        buildHistoryTitle: 'سجل البناء',
        buildHistoryDescription: 'تُحفظ المهام النهائية في Postgres، وتبقى السجلات الكاملة مقروءة من ملفات خادم البناء عند الطلب.',
        buildHistoryLoadingLabel: 'جاري تحميل السجل...',
        buildHistoryCountPattern: '{count} عمليات بناء مطابقة',
        buildHistoryStatusLabel: 'الحالة',
        buildHistorySearchLabel: 'بحث',
        buildHistorySearchPlaceholder: 'فرع، مهمة، علامة',
        buildHistoryApplyLabel: 'تطبيق',
        buildHistoryEmptyCopy: 'لا يوجد سجل بناء مطابق بعد.',
        buildHistoryPageStatusPattern: 'الصفحة {page} من {pageCount} · {total} عملية بناء',
        buildHistoryCreatedPrefix: 'أُنشئت',
        buildHistoryUploadedLabel: 'تم الرفع',
        buildHistoryAriaLabel: 'سجل بناء الإدارة',
        buildHistoryColumns: {
            artifact: 'الأثر',
            branch: 'الفرع',
            duration: 'المدة',
            finished: 'انتهت',
            job: 'المهمة',
            requestedBy: 'طلبها',
            status: 'الحالة',
            track: 'المسار',
        },
        buildHistoryStatusOptions: {
            all: 'الكل',
            cancelled: 'ملغاة',
            failed: 'فشل',
            interrupted: 'انقطع',
            queued: 'في الطابور',
            running: 'قيد التشغيل',
            succeeded: 'نجح',
            terminal: 'نهائية',
        },
        overviewPage: {
            shellTitle: 'مركز العمليات',
            shellDescription: 'الرسائل والصلاحيات والمستخدمون والبلاغات والسجلات وأدوات الفريق لمركز عمليات Chattenger المحمي.',
            heroCardLabel: 'نظرة عامة',
            heroCardTitle: 'أدوات محمية للمشغّلين والدعم والإشراف.',
            heroCardCopy: 'حافظ على رؤية مباشرة للرسائل والمستخدمين والصلاحيات وطوابير التشغيل من مكان واحد.',
            ctaOpenMessages: 'فتح الرسائل',
            ctaOpenStatistics: 'فتح الإحصاءات',
            ctaOpenLogs: 'فتح السجلات',
            ctaOpenDb: 'فتح قاعدة البيانات',
        },
        docsBrowserPage: {
            shellTitle: 'مستندات العمل',
            shellDescription: 'خطط مرجعية ومستندات أولية ومراجع تنفيذ للمشغّلين وضمان الجودة والمراجعة المنتجية.',
            listPaneLabel: 'المستندات',
            listPaneTitle: 'مصادر مرجعية',
            listPaneCopy: 'استخدم هذه المستندات لمصفوفات سلوك ضمان الجودة وتخطيط الإطلاق والعقد المنتجي الحالي.',
            btnSyncSeedDocs: 'مزامنة مستندات البذرة مع قاعدة البيانات',
            btnSyncSeedDocsBusy: 'جاري مزامنة مستندات البذرة…',
            searchLabel: 'بحث في المستندات',
            searchPlaceholder: 'البحث بالعنوان أو المعرّف أو الملخص',
            detailPaneLabel: 'المحدد',
            btnCopyRawMarkdown: 'نسخ Markdown الخام',
            copySuccessMessage: 'تم نسخ Markdown الخام.',
            copyClipboardUnavailable: 'الحافظة غير متاحة في هذا المتصفح.',
            copyFailedFallback: 'تعذّر نسخ Markdown الخام.',
            errSyncSeedDocsFallback: 'تعذّرت مزامنة مستندات البذرة.',
        },
        dbPage: {
            ...EN.admin.dbPage,
            shellEyebrow: 'الإدارة / قاعدة البيانات',
            shellTitle: 'غرفة التحكم PostgreSQL',
            labelActiveDatabase: 'قاعدة البيانات النشطة',
            shellDescription:
                'تصفح قواعد البيانات الحية وفحص المخططات والجداول وتشغيل SQL وإنشاء أدوار PostgreSQL عبر واجهة الإدارة المحمية في الخادم الخلفي.',
        },
        usersPage: {
            shellEyebrow: 'الإدارة / المستخدمون',
            shellTitle: 'إدارة الأدوار العامة',
            shellDescription: 'الأدوار العامة منفصلة عن ملكية مشرف الدردشة العادي. تتحكم هذه الواجهة فقط في common/admin/super_admin.',
            searchLabel: 'بحث',
            searchPlaceholder: 'البحث بالاسم أو المعرف',
            btnSearch: 'بحث',
            tableColUser: 'المستخدم',
            tableColHandle: 'المعرّف',
            tableColRole: 'الدور',
            roleOptionCommon: 'عادي',
            roleOptionAdmin: 'مشرف',
            roleOptionSuperAdmin: 'مشرف أعلى',
            emptyTitle: 'لا يوجد مستخدمون مطابقون',
            emptyCopy: 'سيظهر المستخدمون القابلون لإدارة الأدوار هنا عندما يطابق الاستعلام نتائج.',
            errSearchUsers: 'تعذّر البحث عن المستخدمين',
            errUpdateRole: 'تعذّر تحديث دور المستخدم',
        },
        statsPage: {
            shellEyebrow: 'الإدارة / الإحصاءات',
            shellTitle: 'نشاط CRM والإسناد',
            shellDescription: 'عوامل تصفية وحالة متزامنة مع الرابط وإسناد المشرف المؤقت لعمليات الدعم والأدوار.',
            searchLabel: 'بحث',
            searchPlaceholder: 'ابحث عن الفاعل أو الهدف أو المسار أو النص',
            eventLabel: 'الحدث',
            eventOptionAll: 'كل الأحداث',
            btnApply: 'تطبيق',
            pageStatusPattern: 'الصفحة {page} من {pageCount} · {total} صف',
            paginationNext: 'التالي',
            paginationPrevious: 'السابق',
            tableColTime: 'الوقت',
            tableColEvent: 'الحدث',
            tableColActor: 'الفاعل',
            tableColTarget: 'الهدف',
            tableColPath: 'المسار',
            tableColMessage: 'الرسالة',
            actorSystemLabel: 'system',
            valueEmDash: '—',
            emptyTitle: 'لا صفوف',
            emptyCopy: 'ستظهر هنا صفوف نشاط CRM عندما يعمل المستخدمون ذوو الصلاحيات المرتفعة مع أدوات الدعم والإدارة.',
            errLoadStats: 'تعذر تحميل إحصاءات CRM',
        },
        permissionsPage: {
            shellEyebrow: 'الإدارة / الصلاحيات',
            shellTitle: 'مصفوفة صلاحيات CRM',
            shellDescription: 'أول سطح صلاحيات CRM قابل للتوسيع. يتحكم في وصول المشرفين إلى رسائل الدعم وإحصاءات CRM.',
            tableColPermission: 'الصلاحية',
            tableColRole: 'الدور',
            tableColAccessLevel: 'مستوى الوصول',
            rowPermissionChatWithUsers: 'الدردشة مع المستخدمين',
            accessLevelFull: 'وصول كامل',
            accessLevelRead: 'قراءة فقط',
            accessLevelNone: 'بدون وصول',
            roleUser: 'مستخدم',
            roleAdmin: 'مشرف',
            roleSuperAdmin: 'مشرف أعلى',
            errUpdatePermission: 'تعذّر تحديث هذه الصلاحية',
        },
        authConfigPage: EN.admin.authConfigPage,
        featuresPage: EN.admin.featuresPage,
        mailboxesPage: {
            shellEyebrow: 'الإدارة / صناديق البريد',
            shellTitle: 'حسابات الصندوق والأسماء المستعارة',
            shellDescription: 'سطح تحكم المشرف الأعلى لتسجيلات البريد الحقيقية والأسماء المستعارة والتعيينات وملكية وحدة التحكم المحلية للبيئة.',
            runtimeSectionLabel: 'وقت التشغيل',
            runtimeHostSyncEnabledTitle: 'مزامنة مضيف البريد المحلي للبيئة مفعّلة',
            runtimeHostSyncDisabledTitle: 'مزامنة مضيف البريد معطّلة',
            runtimeMessageFallback: 'معلومات وقت تشغيل البريد غير متاحة.',
            createFormEyebrow: 'إنشاء حساب صندوق بريد',
            createFormTitle: 'حساب جديد',
            btnCreateMailbox: 'إنشاء صندوق',
            fieldSlug: 'المعرّف المختصر',
            fieldDisplayName: 'اسم العرض',
            fieldLoginUser: 'مستخدم تسجيل الدخول',
            fieldPassword: 'كلمة المرور',
            fieldPasswordPlaceholderNewMailbox: 'مطلوب لصندوق نشط جديد',
            fieldPasswordHintKeepCurrent: 'اتركه فارغًا للإبقاء على كلمة المرور الحالية.',
            fieldFromAddress: 'عنوان المرسل',
            fieldFromName: 'اسم المرسل',
            fieldReplyTo: 'الرد على',
            fieldConsoleBinding: 'ربط وحدة التحكم',
            consoleBindingNone: 'بدون ربط وحدة تحكم',
            consoleBindingEmail: '/admin/mail',
            fieldStatus: 'الحالة',
            statusPendingSetup: 'في انتظار الإعداد',
            statusActive: 'نشط',
            statusDisabled: 'معطّل',
            statusArchived: 'مؤرشف',
            fieldSentMailbox: 'مجلد المرسل',
            fieldTrashMailbox: 'مجلد المهملات',
            fieldThreadScanLimit: 'حد فحص المواضيع',
            fieldInboxPageSize: 'حجم صفحة الوارد',
            aliasesSectionLabel: 'أسماء مستعارة',
            btnAddAlias: 'إضافة اسم مستعار',
            btnRemoveAlias: 'إزالة اسم مستعار',
            aliasFieldLabelPattern: 'اسم مستعار {index}',
            checkboxPrimaryAlias: 'اسم مستعار أساسي',
            checkboxEnabled: 'مفعّل',
            assignedUsersLabel: 'مستخدمو Chattenger المعيّنون',
            assignedUsersHintCreate: 'قد يكون للمستخدمين العاديين صندوق واحد فقط. قد يمتلك المشرفون والمشرفون الأعلى عدة صناديق.',
            assignedUsersHintEdit: 'المستخدمون العاديون محدودون بحساب صندوق واحد. قد يمتلك المشرفون والمشرفون الأعلى عدة حسابات.',
            userOptionRoleLine: 'الدور: {role}',
            forceAliasReassignCreate: 'فرض إعادة تعيين الاسم المستعار إذا كان مرتبطًا بمكان آخر',
            forceConsoleKeyReassignCreate: 'فرض نقل ربط وحدة التحكم إذا كانت مرتبطة بمكان آخر',
            forceAliasReassignEdit: 'فرض إعادة تعيين الاسم المستعار',
            forceConsoleKeyReassignEdit: 'فرض نقل ربط وحدة التحكم',
            accountCardEyebrowPattern: 'حساب صندوق بريد #{id}',
            accountLoginUserLabel: 'مستخدم تسجيل الدخول:',
            accountSystemMailboxSuffix: ' • صندوق نظام',
            btnSave: 'حفظ',
            btnArchive: 'أرشفة',
            archiveBlockedConsoleHint: 'أزل ربط وحدة التحكم عن هذا الصندوق قبل أرشفته.',
            archiveBlockedSystemHint: 'حسابات صناديق النظام محجوزة ولا يمكن أرشفتها من هذه الشاشة.',
            errCreateFallback: 'تعذّر إنشاء حساب الصندوق',
            errSaveFallback: 'تعذّر حفظ حساب الصندوق',
            errArchiveFallback: 'تعذّر أرشفة حساب الصندوق',
            errConflictAliasLine: '{value} مرتبط بالفعل بـ {mailboxDisplayName}.',
            errConflictConsoleKeyLine: '{value} مرتبط بالفعل بـ {mailboxDisplayName}.',
            errConflictLoginLine: 'تسجيل الدخول {value} مستخدم بالفعل في {mailboxDisplayName}.',
            createSuccessLine: 'تم إنشاء صندوق {displayName}.',
            saveSuccessLine: 'تم حفظ صندوق {displayName}.',
        },
        ciPage: {
            shellTitle: 'CI',
            shellDescription: 'اختر بيئة وثبت فرعاً وانشر Next.js إلى جذور التشغيل المستقرة دون إعادة استخدام نسخة العمل المتغيرة.',
        },
        wireguardPage: {
            shellTitle: 'WireGuard الداخلي',
            shellDescription:
                'اعرض أقران WireGuard الداخليين لمسار control-plane من المضيف الخارجي وآخر المصافحات وأوقف أقران المشغلين المخترقين دون مغادرة واجهة الإدارة.',
            disablePeerDialogTitle: 'تعطيل القرين',
            summaryPeersLabel: 'الأقران',
            summaryMetaLine: '{active} نشط · {inactive} قديم · {never} لم يتصل أبداً',
            summaryInterfaceLabel: 'الواجهة',
            summaryGeneratedLine: 'تم التوليد في {time}',
            transportPolicyLabel: 'حدود النقل',
            transportPolicyWireguardCopy: 'تتحكم هذه الصفحة في أقران WireGuard القديمة لمسار intranet/control-plane فقط.',
            transportPolicyAmneziaCopy:
                'مضيفو AmneziaWG للـ regular VPN الموجه للمستخدم و VPN+ VLESS/H1Cloud أسطح منفصلة حتى يوفر backend/dev-tools تحكماً حياً واعياً بالنقل.',
            transportPolicyMediaWorkerCopy: 'عمّال الوسائط لـ /transcribe و /describe و Suno خارج هذه الصفحة.',
            snapshotEyebrow: 'لقطة مباشرة',
            snapshotPollCopy: 'يُستطلع كل {seconds} ثانية عندما تكون الصفحة ظاهرة. التعطيل يستخدم المضيف الخارجي مباشرة.',
            peerCountBadge: '{count} قرين',
            badgeNoData: 'لا بيانات',
            btnRefresh: 'تحديث',
            btnRefreshBusy: 'جارٍ التحديث…',
            errLoadPeers: 'تعذّر تحميل أقران WireGuard.',
            tableColPeer: 'القرين',
            tableColStatus: 'الحالة',
            tableColAllowedIps: 'عناوين IP المسموحة',
            tableColHandshake: 'المصافحة',
            tableColTraffic: 'المرور',
            tableColEndpoint: 'نقطة النهاية',
            tableColAction: 'إجراء',
            peerUnlabeled: 'قرين بلا تسمية',
            peerNoIdComment: 'لا تعليق لمعرّف القرين',
            trafficRxPrefix: 'RX',
            trafficTxPrefix: 'TX',
            btnDisable: 'تعطيل',
            emptyTitle: 'لا أقران',
            emptyCopy: 'لم يُرجع WireGuard أقراناً مهيأة لهذه الواجهة، أو المضيف الخارجي غير متاح.',
            sheetDisableWarning: 'يزيل القرين فوراً من واجهة WireGuard الخارجية.',
            sheetPeerLabel: 'القرين',
            sheetStatusLabel: 'الحالة',
            btnCancel: 'إلغاء',
            btnDisablePeer: 'تعطيل القرين',
            btnDisablePeerBusy: 'جارٍ التعطيل…',
            disablePeerSuccessLine: 'تم تعطيل القرين {display}.',
            errDisablePeer: 'تعذّر تعطيل القرين.',
            valueEmDash: '—',
        },
        terminalPage: EN.admin.terminalPage,
        placeholderPage: {
            migrationCardLabel: 'الترحيل قيد التنفيذ',
        },
        infrastructure: {
            ...EN.admin.infrastructure,
            operatorBoundaryEyebrow: 'حدود التشغيل',
            operatorBoundaryTitle: 'مسؤوليات VPN والوسائط',
            operatorBoundaryCopy:
                'تعرض هذه الصفحة تبعيات التشغيل. لا تنشئ أقران VPN ولا تجهز مضيفات AmneziaWG ولا تضبط الحصص ولا تنقل أحمال الوسائط.',
            operatorBoundaryInternalWireguardTitle: 'WireGuard الداخلي',
            operatorBoundaryInternalWireguardCopy:
                'يبقى WireGuard العادي مسار intranet/control-plane للمشغلين، ولا يجب تقديمه كـ regular VPN موجه للمستخدمين.',
            operatorBoundaryRegularVpnTitle: 'Regular VPN: AmneziaWG',
            operatorBoundaryRegularVpnCopy:
                'regular VPN الموجه للمستخدمين يخص AmneziaWG على مضيفات pc_vpn بعد إثبات حي في backend/dev-tools؛ هذه الواجهة تعرض الحدود فقط.',
            operatorBoundaryVpnPlusTitle: 'VPN+: VLESS/H1Cloud',
            operatorBoundaryVpnPlusCopy: 'يبقى VPN+ مسار منتج VLESS/H1Cloud منفصلاً ولا تتحكم به صفحة WireGuard الداخلي.',
            operatorBoundaryMediaWorkerTitle: 'Media worker',
            operatorBoundaryMediaWorkerCopy:
                '/transcribe و /describe و Suno عمل توجيه مستقبلي إلى pc_worker؛ هذه الصفحة لا توحي بوجود تحكم حي في الترحيل.',
            operatorBoundaryNoLiveControlBadge: 'لا تحكم حي',
        },
        mailConsole: EN.admin.mailConsole,
    },
    assistant: {
        ...EN.assistant,
        navLabel: 'المساعد',
        eyebrow: 'المساعد',
        title: 'اسأل مساعد Chattenger',
        description: 'استخدم هذه المساحة المخصصة للمساعد. لا يفتح كمحادثة عادية ولا يظهر كجهة اتصال قابلة للبحث.',
        inputLabel: 'الطلب',
        inputPlaceholder: 'اطلب المساعدة بخصوص Chattenger أو مساحة العمل أو مهمة ويب محددة.',
        submit: 'اسأل',
        submitting: 'جار التفكير…',
        pendingLabel: 'المساعد يكتب…',
        responseLabel: 'الرد',
        unavailableTitle: 'المساعد غير متاح',
        unavailableCopy: 'المساعد غير متاح الآن. حاول لاحقا.',
        emptyCopy: 'تعتمد ردود المساعد على تفعيل مزود backend.',
    },
    vpnPlusShareCode: {
        ...EN.vpnPlusShareCode,
        eyebrow: 'مشاركة VPN+',
        title: 'استلام بيانات VPN+ مشتركة',
        description: 'سجّل الدخول بحساب Chattenger الحالي لنقل رصيد VPN+ المحجوز إلى رصيدك.',
        codeLabel: 'الكود',
        invalidCodeFallback: 'كود غير صالح',
        readyTitle: 'جاهز للاستلام',
        readyCopy: 'يمكن استخدام هذا الكود مرة واحدة فقط. سيتحقق Chattenger منه قبل تغيير رصيد VPN+.',
        redeemAction: 'استلام',
        redeemingAction: 'جارٍ الاستلام…',
        redeemingTitle: 'جارٍ فحص الكود',
        redeemingCopy: 'يتحقق Chattenger من كود VPN+ هذا.',
        redeemedTitle: 'تمت إضافة بيانات VPN+',
        redeemedCopy: 'تمت إضافة رصيد VPN+ المشترك إلى حسابك.',
        expiredTitle: 'انتهت صلاحية الكود',
        expiredCopy: 'لم يعد هذا الكود نشطاً. اطلب من المرسل إنشاء كود جديد.',
        usedTitle: 'الكود مستخدم بالفعل',
        usedCopy: 'تم استلام هذا الكود سابقاً ولا يمكن استخدامه مرة أخرى.',
        cancelledTitle: 'تم إلغاء الكود',
        cancelledCopy: 'ألغى المرسل هذا الكود قبل استلامه.',
        invalidTitle: 'الكود غير متاح',
        invalidCopy: 'هذا الكود غير صالح أو غير مكتمل.',
        featureOffTitle: 'مشاركة VPN+ غير متاحة',
        featureOffCopy: 'استلام أكواد VPN+ غير مفعّل لهذا الحساب الآن.',
        unavailableTitle: 'تعذر الاستلام',
        unavailableCopy: 'تعذر على Chattenger استلام هذا الكود الآن. حاول لاحقاً.',
        copyLink: 'نسخ الرابط',
        copyLinkSuccess: 'تم نسخ رابط VPN+.',
        copyLinkFailed: 'تعذر نسخ هذا الرابط.',
    },
    dashboard: {
        ...EN.dashboard,
        eyebrow: 'اللوحة',
        title: 'سريع ومتزامن وجاهز على كل شاشة.',
        recordings: 'التسجيلات',
        searchChats: 'البحث في الدردشات',
        searchChatsPlaceholder: 'ابحث في الدردشات',
        searchOlderChats: 'يتم البحث في الدردشات الأقدم…',
        searchUsers: 'البحث عن المستخدمين',
        searchUsersPlaceholder: 'ابحث عن مستخدم',
        searchUsersSearching: 'جارٍ البحث عن المستخدمين…',
        searchUsersEmpty: 'لم يتم العثور على مستخدمين',
        quickPeople: 'جهات اتصال سريعة',
        notifications: 'الإشعارات',
        notificationsCopy: 'فعّل الإشعارات حتى تصلك الرسائل والمكالمات داخل المتصفح.',
        allowNotifications: 'السماح بالإشعارات',
        notificationReady: 'الإشعارات جاهزة',
        refreshPush: 'تحديث push',
        disablePush: 'تعطيل push',
        realtimeLabel: 'الاتصال',
        realtimeOnline: 'متصل',
        realtimeConnecting: 'جارٍ الاتصال…',
        realtimeReconnecting: 'جارٍ استعادة الاتصال…',
        realtimeOnlineCopy: 'تصل الرسائل والأحداث فوراً.',
        realtimeConnectingCopy: 'الواجهة جاهزة بينما يكتمل الاتصال.',
        realtimeReconnectingCopy: 'تبقى الرسائل المعلقة محفوظة وتكمل بعد عودة الاتصال.',
        syncLabel: 'المزامنة',
        syncReady: 'جاهز',
        syncRefreshing: 'جارٍ التحديث…',
        syncing: 'جارٍ المزامنة…',
        saving: 'جارٍ الحفظ…',
        hidePreview: 'إخفاء نص الرسالة في معاينات الإشعار',
        showPreview: 'إظهار المعاينة',
        vpn: 'VPN',
        vpnChecking: 'جارٍ فحص حالة VPN الآمنة للمتصفح…',
        channel: 'قناة',
        conversation: 'محادثة',
        attachments: 'المرفقات',
        globalSearchLabel: 'البحث في Chattenger',
        globalSearchTrigger: 'بحث',
        globalSearchPlaceholder: 'ابحث في الدردشات والأشخاص والقنوات',
        searchBack: 'رجوع',
        searchEmptyChats: 'لم يتم العثور على دردشات.',
        searchEmptyChannels: 'لم يتم العثور على قنوات.',
        searchFilterAll: 'الكل',
        searchFilterChannels: 'القنوات',
        searchFilters: 'مرشحات البحث',
        noChatsCompact: 'لا توجد دردشات بعد :(',
        quickCreate: 'إنشاء سريع',
        create: 'إنشاء',
        createChat: 'دردشة جديدة',
        createChannel: 'قناة جديدة',
        createGroup: 'مجموعة جديدة',
        closeSearch: 'إغلاق البحث',
        closeQuickCreate: 'إغلاق قائمة الإنشاء السريع',
        searchInChat: 'البحث داخل المحادثة',
        searchInChatPlaceholder: 'ابحث في الرسائل',
        searchingMessages: 'جارٍ البحث…',
        noHits: 'لا نتائج',
        jumpToLatest: 'الانتقال إلى الأحدث',
        queuedSuffix: 'في الانتظار',
        shellCacheCopy: 'تبقى الدردشات الأخيرة والرسائل المعلقة محفوظة محلياً ليعود التطبيق فوراً.',
        waitingThreadEyebrow: 'لا توجد محادثة محددة',
        waitingThreadTitle: 'اختر محادثة من العمود الأيسر.',
        waitingThreadCopy: 'سيتم تحميل السجل والبحث وطابور الإرسال فور اختيار المحادثة.',
        noChatsEyebrow: 'لا توجد دردشات',
        noChatsCopy: 'ستظهر قائمة الدردشات هنا بعد اكتمال المزامنة.',
        encryptedMessage: 'رسالة مشفرة',
        encryptedThreadEmpty: 'كل الرسائل مشفرة',
        conversationPeerOnline: 'متصل الآن',
        conversationPeerLastSeenRecently: 'متصل مؤخراً',
        conversationPeerLastOnlineAtTime: 'ظهور في {time}',
        conversationPeerLastOnlineDateTime: 'ظهور {date} {time}',
        messageMediaQueuedImage: 'صورة قيد الانتظار',
        messageMediaQueuedVideo: 'فيديو قيد الانتظار',
        messageMediaVideoBadge: 'فيديو',
        messageMediaImageFallback: 'صورة {index}',
        messageMediaVideoFallback: 'فيديو {index}',
        messageMediaThumbnailFallback: 'معاينة',
        circleVideoExpandAria: 'توسيع الفيديو الدائري',
        circleVideoResumeAria: 'استئناف الفيديو الدائري',
        circleVideoCollapseAria: 'طي الفيديو الدائري',
        circleVideoPlaceholder: 'تجري الآن تهيئة معاينة الفيديو الدائري',
        circleVideoPaused: 'متوقف مؤقتاً',
        circleVideoLivePreview: 'معاينة مباشرة',
        circleVideoUnmute: 'تشغيل الصوت',
        circleVideoMute: 'كتم الصوت',
        circleVideoSeekHandleAria: 'تحريك موضع الفيديو الدائري',
    },
    calls: {
        groupCall: 'مكالمة جماعية',
        directCall: 'مكالمة مباشرة',
        waitingMediaEyebrow: 'بانتظار الوسائط',
        waitingMediaTitle: 'الغرفة نشطة بالفعل.',
        waitingMediaCopy: 'شغّل الميكروفون أو الكاميرا أو مشاركة الشاشة لبدء التدفق.',
        roomRecordings: 'تسجيلات الغرفة',
        recordingsSheetPrivateEyebrow: 'خاص بك',
        viewRecordings: 'عرض التسجيلات',
        callHistory: 'المكالمات',
        callHistoryTitle: 'المكالمات والتسجيلات والأنشطة المباشرة',
        callHistoryCopy: 'راجع الغرف الأخيرة وافتح تسجيلاتك الخاصة وتابع أنشطة المكالمات من مساحة مدمجة واحدة.',
        callHistoryEmpty: 'ستظهر المكالمات هنا بعد بدء غرفة أو الانضمام إليها.',
        callHistoryRefresh: 'تحديث',
        callHistoryRefreshing: 'جارٍ التحديث…',
        callHistoryRecordings: 'التسجيلات',
        callHistoryActivities: 'الأنشطة',
        activities: 'الأنشطة',
        activitiesMenu: 'أنشطة المكالمة',
        scrumPoker: 'سكرم بوكر',
        retroBoard: 'لوحة الاسترجاع',
        startScrumPoker: 'ابدأ البوكر',
        startRetroBoard: 'ابدأ الريترو',
        activityLoadFailed: 'تعذر تحميل أنشطة المكالمة.',
        activityCreateFailed: 'تعذر إنشاء النشاط.',
        activityUpdateFailed: 'تعذر تحديث النشاط.',
        noActivities: 'لا توجد أنشطة في هذه الغرفة بعد.',
        revealCards: 'اكشف البطاقات',
        cardsRevealed: 'تم كشف البطاقات',
        pokerVotePrompt: 'اختر بطاقتك',
        pokerWaitingReveal: 'تبقى الأصوات مخفية حتى يكشفها المسؤول.',
        pokerAverage: 'المتوسط {value}',
        retroBoardAddNote: 'ملاحظة',
        retroBoardAddText: 'نص',
        retroBoardAddRectangle: 'مستطيل',
        retroBoardAddEllipse: 'قطع ناقص',
        retroBoardSave: 'حفظ اللوحة',
        retroBoardViewOnly: 'عرض فقط',
        retroBoardMoveHint: 'اسحب اللوحة للتحريك، واستخدم العجلة أو الأزرار للتكبير، واسحب العناصر لترتيب الاسترجاع.',
        retroBoardZoomIn: 'تكبير',
        retroBoardZoomOut: 'تصغير',
        retroBoardResetView: 'إعادة ضبط العرض',
        incomingEyebrow: 'مكالمة واردة',
        incomingCopy: 'بانتظار ردك في هذا المتصفح',
        incomingBusyCopy: 'أنه المكالمة الحالية أولاً قبل الانتقال',
        incomingBusyLabel: 'هناك مكالمة أخرى نشطة',
        answer: 'رد',
        decline: 'رفض',
        leave: 'مغادرة',
        microphoneLabel: 'الميكروفون',
        videoLabel: 'الكاميرا',
        microphoneOn: 'الميكروفون يعمل',
        microphoneOff: 'الميكروفون متوقف',
        cameraOn: 'الكاميرا تعمل',
        cameraOff: 'الكاميرا متوقفة',
        shareScreen: 'مشاركة الشاشة',
        stopShare: 'إيقاف المشاركة',
        hideSelf: 'إخفاء نفسي',
        showSelf: 'إظهار نفسي',
        audioDevices: 'أجهزة الصوت',
        videoDevices: 'أجهزة الفيديو',
        microphoneDevice: 'الميكروفون',
        participantVolume: 'مستوى صوت المشارك',
        speakerDevice: 'مخرج الصوت',
        cameraDevice: 'الكاميرا',
        backgroundEffects: 'الخلفية',
        backgroundOff: 'بدون',
        backgroundBlur: 'تمويه',
        backgroundLogo: 'Pigeon',
        backgroundUnavailable: 'تأثيرات الخلفية تحتاج إلى متصفح مدعوم وجهاز قوي بما يكفي.',
        backgroundUsesSelectedOutput: 'تُطبَّق الخلفية المختارة على بث الكاميرا الذي يراه المشاركون وتسجيلات المكالمة.',
        sameAsSystem: 'مثل النظام',
        audioProcessing: 'معالجة الصوت',
        micGain: 'مستوى صوت الميكروفون',
        micGainHint: 'ينطبق على الميكروفون المباشر وعلى تسجيلات المكالمة.',
        noiseSuppression: 'خفض الضوضاء',
        echoCancellation: 'إلغاء الصدى',
        autoGainControl: 'التحكم التلقائي في الكسب',
        audioOutputUnavailable: 'اختيار مخرج الصوت غير متاح في هذا المتصفح. سيتم استخدام مخرج النظام.',
        deviceChangesApplyCopy: 'تبديل الميكروفون أو السماعة أو الكاميرا يطبّق فوراً من دون إعادة الانضمام إلى الغرفة.',
        recordingUsesSelectedDevices:
            'تسجيلات المكالمة الجارية تستخدم الميكروفون والكاميرا ومستوى صوت الميكروفون وإعدادات معالجة الصوت المختارة تلقائياً. مخرج السماعة يؤثر فقط على التشغيل على هذا الجهاز.',
        callEndedUnexpectedly: 'انتهت المكالمة بشكل غير متوقع.',
        callParticipantUnavailable: 'تعذّر توصيل المكالمة لأنه لا يوجد أي مشارك متاح الآن.',
        callConnectionUnavailable: 'المكالمات غير متاحة مؤقتاً. حاول مرة أخرى بعد دقيقة.',
        callParticipantBusy: 'هذا المشارك موجود بالفعل في مكالمة أخرى.',
        callAnsweredElsewhere: 'تم الرد على هذه المكالمة على جهاز آخر.',
        layoutPreviewEyebrow: 'معاينة التخطيط',
        layoutPreviewCopy: 'تبقى هذه المعاينة محلية داخل هذا المتصفح. لن تبدأ أي مكالمة أو عملية تسجيل حقيقية.',
        switchCamera: 'تبديل الكاميرا',
        callMenu: 'قائمة المكالمة',
        devicesAndRecording: 'الأجهزة والتسجيل',
        videoChatParticipants: 'مشاركو مكالمة الفيديو',
        screenSharingMenu: 'مشاركة الشاشة',
        participantsOnCall: '{count} مشاركاً في المكالمة',
        screenShareActive: 'مشاركة الشاشة نشطة',
        screenSharingParticipantLabel: 'يشارك الشاشة: {name}',
        screenShareEmpty: 'لا أحد يشارك الشاشة الآن.',
        backToMenu: 'رجوع',
        fullscreenPreview: 'معاينة كاملة الشاشة',
        ongoingCallLabel: 'مكالمة جارية',
        ongoingCallParticipants: '{count} أشخاص متصلون',
        expand: 'توسيع',
        minimizeCall: 'تصغير المكالمة',
        backToAutomaticLayout: 'العودة إلى التخطيط التلقائي',
        liveNow: 'مباشر الآن',
        mutedLabel: 'صامت',
        recordingStart: 'بدء التسجيل',
        recordingPause: 'إيقاف التسجيل مؤقتاً',
        recordingResume: 'استئناف التسجيل',
        compactActionMore: 'المزيد',
        compactActionMicrophone: 'الميكروفون',
        compactActionCamera: 'الكاميرا',
        compactActionRecord: 'تسجيل',
        compactActionPause: 'إيقاف',
        compactActionResume: 'متابعة',
        compactActionSwitchCamera: 'تبديل',
        compactActionLeave: 'مغادرة',
        directPreviewSwap: 'تبديل المعاينة',
        directPreviewHide: 'إخفاء المعاينة',
        directPreviewRestore: 'إرجاع المعاينة',
        screenShareUnsupported: 'مشاركة الشاشة غير متاحة في هذا المتصفح.',
        screenSharePermissionHint: 'اسمح بالتقاط الشاشة لمشاركة شاشتك أو علامة التبويب.',
        screenShareCanceled: 'تم إلغاء مشاركة الشاشة.',
        screenShareStartFailed: 'تعذر بدء مشاركة الشاشة.',
    },
    assetViewer: {
        dialogLabel: 'عارض المرفقات',
        thumbnailsLabel: 'العناصر',
        open: 'فتح',
        download: 'تنزيل',
        downloadCurrent: 'هذا العنصر فقط',
        downloadAll: 'كل العناصر',
        downloadChoiceTitle: 'ماذا تريد تنزيله؟',
        downloadChoiceDescription: 'احفظ العنصر الحالي فقط أو ابدأ تنزيل كل مرفقات هذه الرسالة.',
        previous: 'العنصر السابق',
        next: 'العنصر التالي',
        videoBadge: 'فيديو',
        pdfBadge: 'PDF',
        fileBadge: 'ملف',
    },
    mail: {
        attachments: 'المرفقات',
        files: 'الملفات',
        shellTitle: 'صندوق البريد',
        workspaceNavigationLabel: 'تنقل مساحة العمل',
        workspaceTitle: 'صندوق البريد',
        mailboxLabel: 'صندوق البريد',
        actionNewEmail: 'رسالة جديدة',
        actionRefreshMailbox: 'تحديث',
        actionDeleteMailbox: 'حذف الصندوق',
        threadsLabel: 'السلاسل',
        searchThreadsLabel: 'البحث في السلاسل',
        filterAllThreads: 'الكل',
        filterIncomingThreads: 'الوارد',
        filterAttachmentThreads: 'المرفقات',
        inboxQuietCopy: 'ستظهر السلاسل هنا عندما يستقبل هذا الصندوق أو يرسل بريداً.',
        inboxQuietEyebrow: 'لا محادثات بعد',
        inboxQuietSearchCopy: 'لا توجد سلاسل تطابق هذا البحث الآن.',
        inboxQuietTitle: 'صندوق الوارد هادئ',
        incoming: 'الوارد',
        noMailboxDefaultCopy: 'سيكون صندوقك الافتراضي',
        noMailboxEyebrow: 'البريد',
        noMailboxSidebarCopy: 'أنشئ أول صندوق بريد لبدء إرسال واستقبال البريد.',
        noMailboxSidebarTitle: 'لا يوجد صندوق بريد بعد',
        noMailboxTitle: 'ليس لديك صندوق بريد إلكتروني بعد',
        sent: 'المرسل',
        productDraftNavEyebrow: 'مسودة غير محفوظة',
        productDraftNavTitle: 'مغادرة هذه المسودة؟',
        productDraftNavCopy: 'المسودة محفوظة محلياً، لكن هذا الانتقال سيغلق وضع الكتابة الحالي.',
        productDraftNavStay: 'البقاء هنا',
        productDraftNavLeave: 'مغادرة المسودة',
        productMailboxDeleteEyebrow: 'دورة حياة صندوق البريد',
        productMailboxDeleteTitle: 'حذف صندوق البريد؟',
        productMailboxDeleteCopyGeneric: 'احذف هذا الصندوق من واجهة المنتج. يمكنك استعادته لاحقاً.',
        productMailboxDeleteCopyWithAddress: 'احذف {address} من واجهة المنتج. يمكنك استعادته لاحقاً من الحالة الفارغة.',
        productMailboxDeleteKeep: 'الإبقاء على الصندوق',
        productMailboxDeleteConfirm: 'حذف صندوق البريد',
        productMailboxDeleteBusy: 'جارٍ الحذف…',
        composeLabel: 'إنشاء',
        composeReplyHeading: 'رد',
        composeForwardHeading: 'إعادة توجيه',
        composeSendingAsPattern: 'الإرسال بصفة {address}',
        actionCancel: 'إلغاء',
        messageLabel: 'الرسالة',
        threadLabel: 'السلسلة',
        noSubject: '(بدون عنوان)',
        threadMessageCountOne: '{count} رسالة',
        threadMessageCountMany: '{count} رسائل',
        actionReply: 'رد',
        actionForward: 'إعادة توجيه',
        actionDeleteMessage: 'حذف',
        unknownSender: 'مرسل غير معروف',
        unknownDate: 'تاريخ غير معروف',
        fromLabel: 'من',
        toLabel: 'إلى',
        ccLabel: 'نسخة',
        dateLabel: 'التاريخ',
        deliveryLabel: 'التسليم',
        emptyThreadTitle: 'اختر سلسلة من الشريط الجانبي',
        emptyThreadCopy: 'افتح محادثة أو ابدأ رسالة صادرة جديدة.',
        errRefreshMailbox: 'تعذر تحديث هذا الصندوق',
        errOpenMailbox: 'تعذر فتح هذا الصندوق',
        errOpenThread: 'تعذر فتح هذه السلسلة',
        actionCreateMailbox: 'إنشاء صندوق',
        actionRestoreMailbox: 'استعادة الصندوق',
        successMailboxCreated: 'تم إنشاء الصندوق',
        errCreateMailbox: 'تعذر إنشاء هذا الصندوق',
        successMailboxRestored: 'تمت استعادة الصندوق',
        errRestoreMailbox: 'تعذرت استعادة هذا الصندوق',
        successMailboxDeleted: 'تم حذف الصندوق',
        errDeleteMailbox: 'تعذر حذف هذا الصندوق',
        errStageAttachments: 'تعذر تجهيز المرفقات',
        successEmailAccepted: 'تم قبول البريد للتسليم',
        errSendEmail: 'تعذر إرسال هذا البريد',
        successMessageMovedToTrash: 'تم نقل الرسالة إلى المهملات',
        errDeleteMessage: 'تعذر حذف هذه الرسالة',
        composerAddAttachments: 'إضافة مرفقات',
        composerSend: 'إرسال',
        composerSending: 'جارٍ الإرسال…',
        composerHint: 'اسحب الملفات إلى هنا، أو الصق لقطات الشاشة، أو اضغط Cmd/Ctrl+Enter للإرسال.',
        composerRemoveAttachmentAria: 'إزالة {fileName}',
    },
    recordings: {
        eyebrow: 'التسجيلات',
        title: 'جلسات تسجيل الغرف الخاصة بك عبر الأجهزة.',
        listTitle: 'التسجيلات',
        noRecordingsEyebrow: 'لا توجد تسجيلات بعد',
        noRecordingsTitle: 'ستظهر جلسات التسجيل الخاصة بك هنا.',
        noRecordingsCopy: 'ابدأ تسجيل مكالمة جماعية على الويب أو الجوال، وسيظهر كل تسجيل خاص بالجهاز كعنصر مستقل هنا.',
        detailEyebrow: 'تفاصيل التسجيل',
        playback: 'التشغيل',
        downloadMp4: 'تنزيل MP4',
        sceneManifest: 'بيان المشاهد',
        playbackPending: 'هذا التسجيل ما زال ينتظر انتهاء المكالمة أو التغليف النهائي قبل إتاحة التشغيل.',
        playbackFailed: 'فشل هذا التسجيل أثناء تحضير الأثر.',
        searchRecordingsLabel: 'البحث في التسجيلات',
        filterAll: 'الكل',
        filterReady: 'جاهز',
        filterActive: 'نشط',
        newBadge: 'جديد',
        previewLabel: 'معاينة',
        sortRecent: 'الأحدث',
        sortChat: 'المحادثة',
        sortStatus: 'الحالة',
        roomLabel: 'الغرفة #{roomId}',
        chatFallbackLabel: 'الدردشة {chatId}',
        createdLabel: 'تم الإنشاء',
        roomStateLabel: 'حالة الغرفة',
        roomStateEnded: 'انتهت المكالمة',
        roomStateRecordingLive: 'التسجيل جارٍ',
        roomStateNoActive: 'لا يوجد تسجيل نشط',
        roomActivityLabel: 'نشاط الغرفة',
        roomActivityCount: 'الجلسات النشطة: {count}',
        roomActivityIdle: 'خاملة',
        artifactLabel: 'الأثر',
        durationLabel: 'المدة',
        durationSeconds: '{seconds}ث',
        playbackReadyLabel: 'جاهز للفتح',
        playbackPendingLabel: 'ليس جاهزاً بعد',
        details: 'التفاصيل',
        paginationPrevious: 'السابق',
        paginationNext: 'التالي',
        paginationStatus: 'الصفحة {current} من {total}',
        lastStartedLabel: 'آخر بدء',
        pausedAtLabel: 'توقف عند',
        pendingRoomEndLabel: 'نهاية الغرفة معلقة',
        sealedAtLabel: 'تم الختم عند',
        artifactReadyLabel: 'الأثر جاهز',
        artifactFailedLabel: 'فشل الأثر',
        sessionIdLabel: 'معرّف الجلسة',
        ownerDeviceLabel: 'جهاز المالك',
        ownerOtherDeviceLabel: 'جهاز آخر #{deviceId}',
        artifactStatusLabel: 'حالة الأثر',
        artifactDurationLabel: 'مدة الأثر',
        artifactSizeLabel: 'حجم الأثر',
        sizeMegabytes: '{size} MB',
        artifactErrorLabel: 'خطأ الأثر',
        recordedIntervalsLabel: 'الفترات المسجلة',
        timeRangePattern: '{start} → {end}',
        ownerPrivateRecordingTitle: 'تسجيل owner-private',
        copiedLabel: 'تم النسخ',
        copyFailedLabel: 'فشل النسخ',
        copyDetailsLabel: 'نسخ التفاصيل',
        playPlaybackLabel: 'تشغيل',
        pausePlaybackLabel: 'إيقاف',
        seekPlaybackLabel: 'تحريك التشغيل',
        rewindTenSecondsLabel: 'رجوع 10 ثوانٍ',
        forwardTenSecondsLabel: 'تقديم 10 ثوانٍ',
        enterFullscreenLabel: 'فتح ملء الشاشة',
        exitFullscreenLabel: 'إغلاق ملء الشاشة',
        processingTimelineLabel: 'الخط الزمني للمعالجة',
        summaryRecordingLine: 'التسجيل #{id}',
        summaryRoomLine: 'الغرفة #{roomId}',
        summaryStatusLine: 'الحالة: {status}',
        summaryArtifactLine: 'الأثر: {artifact}',
    },
    uiKit: {
        shellEyebrow: 'الإدارة / مجموعة واجهة المستخدم',
        title: 'مجموعة واجهة الويب',
        description: 'العناصر المشتركة المستخدمة عبر تسجيل الدخول واللوحة والمكالمات والأسطح الإدارية في Chattenger.',
        buttonsAndBadges: 'الأزرار والوسوم',
        inputsAndSelects: 'الحقول والاختيارات',
        structuredInput: 'إدخال منظم',
        overlayTitle: 'اللوحة المنزلقة',
        overlayCopy: 'تعيد اللوحات mobile-first استخدام المعالجة نفسها المستخدمة في مستكشف مرفقات الدردشة.',
        openShowcaseSheet: 'افتح لوحة العرض',
        showcaseSheetEyebrow: 'مجموعة واجهة المستخدم',
        showcaseSheetTitle: 'لوحة العرض',
        showcaseSheetCopy: 'مكوّن اللوحة المنزلقة هو الأساس المشترك للأسطح المتحركة mobile-first في عميل الويب الجديد.',
        actionsCardLabel: 'إجراءات',
        demoButtonPrimary: 'أساسي',
        demoButtonSecondary: 'ثانوي',
        demoButtonGhost: 'شفاف',
        demoButtonCompact: 'مضغوط',
        badgeDefaultDemo: 'افتراضي',
        badgeAccentDemo: 'تمييز',
        badgeMutedDemo: 'خافت',
        badgeDangerDemo: 'خطر',
        selectionCardLabel: 'اختيار',
        roleSelectLabel: 'الدور',
        resourcesSelectLabel: 'الموارد',
        resourcesHint: 'اختيار تمثيلي لموارد CRM.',
        resourceOptionMessages: 'الرسائل',
        resourceOptionStats: 'الإحصاءات',
        resourceOptionPermissions: 'الصلاحيات',
        resourceOptionUsers: 'المستخدمون',
        structuredCardLabel: 'إدخال منظم',
        arrayInputLabel: 'رسائل البريد للإشعارات',
        arrayInputAddLabel: 'إضافة بريد',
        overlaysCardLabel: 'الطبقات',
        tabsShowcaseLabel: 'عرض مجموعة واجهة المستخدم',
        catalogNavigationLabel: 'أقسام كتالوج واجهة المستخدم',
        catalogControlsTab: 'عناصر التحكم',
        catalogFeedbackTab: 'الحالات والطبقات',
        catalogDataTab: 'البيانات والوسائط',
        catalogTextFieldLabel: 'عنوان الإشعارات',
        catalogTextFieldHint: 'تظهر حالات العادي والمعطل والتحقق معاً.',
        catalogTextFieldError: 'أدخل عنواناً كاملاً.',
        catalogOtpLabel: 'رمز لمرة واحدة',
        catalogSliderLabel: 'قيمة المعاينة',
        catalogArrayPlaceholder: 'أدخل عنوان إشعارات',
        catalogRemoveValueLabel: 'إزالة القيمة',
        catalogEmptySelection: 'لا يوجد اختيار',
        catalogSelectAction: 'اختيار',
        catalogSelectedAction: 'محدد',
        catalogLoadingLabel: 'جارٍ تحميل معاينة المكوّن',
        catalogSettingsLabel: 'إعدادات الكتالوج',
        catalogToastAction: 'إظهار إشعار',
        catalogToastMessage: 'اكتمل إجراء معاينة واجهة المستخدم.',
        catalogTableLabel: 'جدول حالة المكوّن',
        catalogTableColumnComponent: 'المكوّن',
        catalogTableColumnState: 'الحالة',
        catalogTableValueReady: 'جاهز',
        catalogEmptyStateTitle: 'لا توجد سجلات نموذجية',
        catalogEmptyStateCopy: 'لا تطابق أي سجلات نموذجية حالة الكتالوج هذه.',
        catalogShowEmptyState: 'إظهار الحالة الفارغة',
        catalogShowPopulatedState: 'إظهار الحالة المعبأة',
        catalogQrTitle: 'رمز QR لعنصر الكتالوج',
        catalogMediaAction: 'فتح معاينة الوسائط',
        catalogMediaLabel: 'معاينة مرفق الكتالوج',
        catalogMediaMeta: 'عنصر كتالوج محلي آمن',
        roleDemoUser: 'مستخدم عادي',
        roleDemoAdmin: 'مشرف',
        roleDemoSuperAdmin: 'مشرف أعلى',
    },
};
